import PropTypes from 'prop-types'
import React from 'react'
import TextBodySmall from 'components/TextBodySmall'

function ListRowMeta ({ children }) {
  return (
    <TextBodySmall>
      {children}
    </TextBodySmall>
  )
}

ListRowMeta.propTypes = {
  children: PropTypes.string.isRequired
}

export default ListRowMeta
